import { FeatureFlags } from '../../FeatureFlags';

export const productionTenants = [
    {
        name: 'amsterdam',
        fullName: 'Gemeente Amsterdam',
        pageTitle: 'ZXY Cloud',
        applicationName: 'ZXY - Inspectie Portaal',
        customerVersion: 'amsterdam',
        featureFlags: [FeatureFlags.AmsterdamOverspanningen],
        loginUrl: 'https://amsterdam.zxy-cloud.com',
        isVisibleOnLandingPage: true,
    },
    {
        name: 'utrecht',
        fullName: 'Gemeente Utrecht',
        pageTitle: 'Utrecht - ZXY Cloud',
        applicationName: 'Gemeente Utrecht - Inspectie Portaal',
        customerVersion: 'utrecht',
        loginUrl: 'https://utrecht.zxy-cloud.com',
        isVisibleOnLandingPage: true,
    },
    {
        name: 'dordrecht',
        fullName: 'Gemeente Dordrecht',
        pageTitle: 'Dordrecht - ZXY Cloud',
        applicationName: 'Gemeente Dordrecht - Inspectie Portaal',
        customerVersion: 'dordrecht',
        loginUrl: 'https://dordrecht.zxy-cloud.com',
        isVisibleOnLandingPage: true,
    },
    {
        name: 'hyperplane',
        fullName: 'Hyperplane',
        pageTitle: 'Hyperplane - ZXY Cloud',
        applicationName: 'Hyperplane',
        customerVersion: 'hyperplane',
        loginUrl: 'https://hyperplane.zy-cloud.com',
        isVisibleOnLandingPage: false,
    },
    {
        name: 'rijksvastgoed',
        fullName: 'Rijksvastgoedbedrijf',
        pageTitle: 'Rijksvastgoed Inspectie Portaal',
        applicationName: 'Rijksvastgoed Inspectie Portaal',
        customerVersion: 'rijksvastgoed',
        loginUrl: 'https://rijksvastgoed.zxy-cloud.com',
        isVisibleOnLandingPage: true,
    },
    {
        name: 'rws',
        fullName: 'Rijkswaterstaat',
        pageTitle: 'RWS - Inspectie Portaal',
        applicationName: 'RWS Inspectie Portaal',
        customerVersion: 'rws',
        loginUrl: 'https://rws.zxy-cloud.com',
        isVisibleOnLandingPage: true,
    },
    {
        name: 'terra-3dinspect',
        fullName: 'Terra Inspectioneering',
        pageTitle: 'Terra 3D inspect',
        applicationName: 'Terra 3D-Inspect',
        customerVersion: 'ronik',
        forgotPasswordMailTo: 'support@terra-inspectioneering.com?subject=Request new password!',
        supportMailTo: 'support@terra-inspectioneering.com?subject=Support request',
        loginUrl: 'https://terra-3dinspect.com',
        isVisibleOnLandingPage: true,
    },
    {
        name: 'aquasmartxl',
        pageTitle: 'AquaSmartXL - Inspectie Portaal',
        applicationName: 'AquaSmartXL',
        customerVersion: 'aquasmart',
        loginUrl: 'https://aquasmartxl.zxy-cloud.com',
        isVisibleOnLandingPage: false,
    },
    {
        name: 'demo',
        fullName: 'ZXY-Cloud Demo omgeving',
        pageTitle: 'ZXY Cloud Demo',
        applicationName: 'ZXY Cloud Demo',
        loginUrl: 'https://demo.zxy-cloud.com',
        isVisibleOnLandingPage: true,
    },
];
